import { differenceInMinutes } from 'date-fns';
import { isSameDay, timestampToDate } from './dateTimeUtils';
import { t } from '../i18n';

declare const window: any;

/**
 * 计算长时间停留标签
 * @param lastDeliveryTime 上次操作妥投/失败时间（Unix时间戳，秒）
 * @param taskDate 任务日期
 * @param currentTime 当前时间（可选，默认使用当前时间）
 * @returns 标签信息，如果不需要展示则返回 null
 */
export const calculateLongStayLabel = (
    lastDeliveryTime: number | null | undefined,
    taskDate: Date,
    currentTime: Date = new Date()
): { text: string; color: string } | null => {
    // 如果没有上次操作时间，不展示标签
    if (!lastDeliveryTime) {
        return null;
    }

    // 判断是否在 task date 当日（使用工具函数）
    if (!isSameDay(taskDate, currentTime)) {
        return null;
    }

    // 将时间戳转换为Date对象（使用工具函数）
    const lastDeliveryDate = timestampToDate(lastDeliveryTime);

    // 计算停留时长（分钟）：当前时间 - 上次操作妥投/失败时间（使用工具函数）
    const stayMinutes = differenceInMinutes(currentTime, lastDeliveryDate);

    // 如果停留时长 <= 30分钟，不展示标签
    if (stayMinutes <= 30) {
        return null;
    }

    // 格式化停留时长
    const hours = Math.floor(stayMinutes / 60);
    const minutes = stayMinutes % 60;

    let stayText: string;
    if (hours > 0) {
        const hourUnit = hours === 1 ? t('time.hour') : t('time.hours');
        const minuteUnit = minutes === 1 ? t('time.minute') : t('time.minutes');
        stayText = `${hours} ${hourUnit} ${minutes} ${minuteUnit}`;
    } else {
        const minuteUnit = minutes === 1 ? t('time.minute') : t('time.minutes');
        stayText = `${minutes} ${minuteUnit}`;
    }

    // 确定标签颜色：30-60min 橙色，60min以上 红色
    const color = stayMinutes >= 60 ? 'red' : 'orange';

    return {
        text: t('pages.dsp.operationalData.longStayLabel', { duration: stayText }),
        color: color
    };
};
